import { match } from 'ts-pattern';
import { Pill, type PillProps, type PillVariant } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import { IxcMutualfundsV1FundOrderAction } from '@interxfi/types/generated/api';

interface MutualFundsFundOrderActionPillProps extends Omit<PillProps, 'children' | 'variant'> {
  action: IxcMutualfundsV1FundOrderAction | undefined;
}

export function MutualFundsFundOrderActionPill({ isPending, loadingCharacters = 8, action, ...props }: MutualFundsFundOrderActionPillProps) {
  return (
    <Pill
      isPending={!action || isPending}
      loadingCharacters={loadingCharacters}
      {...props}
      variant={match(action)
        .returnType<PillVariant>()
        .with(IxcMutualfundsV1FundOrderAction.Purchase, () => 'green')
        .with(IxcMutualfundsV1FundOrderAction.Redeem, () => 'danger')
        .otherwise(() => 'neutral')}
    >
      <TranslatedText defaultValue={action} i18nKey={{ namespace: 'ixcMutualfundsV1', enumName: 'IxcMutualfundsV1FundOrderAction', value: action }} />
    </Pill>
  );
}
